import { SMRuleFormData } from '../../../integrated-client/models'

export interface IRuleData {
  ruleFormData?: SMRuleFormData
  validation?: any
  readyToSaveRuleForm: boolean
}
export class RuleData implements IRuleData {

  ruleFormData?: SMRuleFormData
  validation?: any
  readyToSaveRuleForm: boolean

  constructor() {
    this.readyToSaveRuleForm = false;
  }
}